"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditImageStatus = void 0;
var EditImageStatus;
(function (EditImageStatus) {
    EditImageStatus[EditImageStatus["OPEN"] = 0] = "OPEN";
    EditImageStatus[EditImageStatus["ERROR"] = 1] = "ERROR";
    EditImageStatus[EditImageStatus["COMPLETE"] = 2] = "COMPLETE";
})(EditImageStatus || (exports.EditImageStatus = EditImageStatus = {}));
